import { render, staticRenderFns } from "./link.vue?vue&type=template&id=123aa285&scoped=true"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"
import style0 from "./link.vue?vue&type=style&index=0&id=123aa285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123aa285",
  null
  
)

export default component.exports